import { get } from 'lodash';
import { axiosService } from '../../services/axiosService';
import { useCreateMutation, MutationOptions } from '../../CRUD';
import { waitlistBaseModel } from './crud';
import { TWaitlist, TWaitlistUpdatePositionParams } from './types';

async function waitlistUpdatePositionQuery({
  selectedProviderId,
  dragWaitlistId,
  targetWaitlistId,
}: TWaitlistUpdatePositionParams) {
  const response = await axiosService.post<TWaitlist[]>(
    `/waitlists/move/update-position/${selectedProviderId}/${dragWaitlistId}/${targetWaitlistId}`,
  );
  return get(response, 'data.response');
}

export const waitlistUpdatePosition =
  () => (options?: MutationOptions<TWaitlist>) =>
    useCreateMutation<TWaitlist>(
      [...waitlistBaseModel.keys.many()],
      waitlistUpdatePositionQuery,
      waitlistBaseModel.keys.fetchKey,
      options,
    );
